import React from "react";
import { useHistory } from 'react-router-dom';
import { Menu, Dropdown } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { companyUseMutation } from '../hooks';

import CompanyConst from '../company-const';
import { EntityRemoveButton, Localize } from 'components/service';
import Icons from 'components/icons';




const CompanyActionField = ({ companyId, companyName, variables }) => {

    const history = useHistory();

    const {
        _setMutationCompanyDelete,
        loadingMutationCompanyDelete,
    } = companyUseMutation.delete(companyId, variables);


    const menu = (
        <Menu
            items={ [
                {
                    label: <Localize>MENUS_DROP.Label_Edit</Localize>,
                    key: '1',
                    icon: <Icons.Edit />,
                    onClick: () => history.push(`${ CompanyConst.basePath }/${ companyId }`)
                },
                {
                    key: '2',
                    disabled: false,
                    icon:
                        <> { false ?
                            <span style={ { display: 'flex', alignItems: 'center' } } ><Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize></span> :

                            <EntityRemoveButton
                                modalButton={
                                    <span style={ { display: 'flex', alignItems: 'center' } } ><Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize></span>
                                }
                                nameEntity={ Localize({ children: "ENTITY.Modal_Title_Company" }).props.children }
                                dataNameEntity={ companyName }
                                loading={ loadingMutationCompanyDelete }
                                deleteMutation={ _setMutationCompanyDelete }
                                variables={ {
                                    id: companyId,
                                } }
                            /> }
                        </>,
                },
            ] }
        />
    );

    return (
        <Dropdown
            // trigger={['click']}
            placement="bottomRight"
            overlay={ menu }
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    )
};

export default CompanyActionField;

